module.exports = __webpack_public_path__ + "d4be76d409a26525b4095bf9057b0ef3.jpg";